module.exports = __webpack_public_path__ + "src/images/products/trendsetter/99_Baldwin Henley Slim Straight Sand.png";